import React from "react";
import { Row, Col, Container } from "reactstrap";
import "../styles/ExclusiveFeatures.css"; // Ensure this is updated for styles

const ExclusiveFeatures = () => {
  return (
    <div className="description-bg">
      <Container>
        <h2 className="what-exactly-is-exclusive text-center mb-5">
          Exciting Features on the Online Orion Stars App
        </h2>
        <p style={{ textAlign: "center" }}>
          Orion Stars is a feature-packed gaming app offering an unforgettable
          gaming experience with the following exciting features:{" "}
        </p>
        <Row className="variety-wrapper variety-wrapper-1">
          <Col xs={12} sm={12} md={6} lg={3} className="content-box mb-4">
            <div className="feature-card">
              <i className="bi bi-laptop feature-icon"></i> {/* Icon */}
              <h3 className="feature-title">User-Friendly Interface</h3>
              <p className="feature-description">
                With our intuitive, user-friendly interface, you can spend less
                time navigating and more time playing your favorite game. Jump
                into action right away and enjoy a hassle-free experience.
              </p>
            </div>
          </Col>

          <Col xs={12} sm={12} md={6} lg={3} className="content-box mb-4">
            <div className="feature-card">
              <i className="bi bi-gift feature-icon"></i>
              <h3 className="feature-title">Exclusive Bonus</h3>
              <p className="feature-description">
                Get exclusive bonuses and rewards. Orion Stars offers a 200%
                bonus on the first deposit, regular promotions, free spins, and
                much more. Play more and earn more.
              </p>
            </div>
          </Col>

          <Col xs={12} sm={12} md={6} lg={3} className="content-box mb-4">
            <div className="feature-card">
              <i className="bi bi-cart feature-icon"></i>
              <h3 className="feature-title">In-game Purchase</h3>
              <p className="feature-description">
                Get additional spins, unlock new features and power-ups, and
                customize your gameplay with easy and convenient in-game
                purchases.
              </p>
            </div>
          </Col>
        </Row>

        <Row className="variety-wrapper variety-wrapper-1">
          <Col xs={12} sm={12} md={6} lg={3} className="content-box mb-4">
            <div className="feature-card">
              <i className="bi bi-heart feature-icon"></i>
              <h3 className="feature-title">Loyalty Programs</h3>
              <p className="feature-description">
                Access exciting loyalty programs and unlock free spins,
                personalized bonuses, exclusive perks, and other rewards.
              </p>
            </div>
          </Col>

          <Col xs={12} sm={12} md={6} lg={3} className="content-box mb-4">
            <div className="feature-card">
              <i className="bi bi-shield-lock feature-icon"></i>
              <h3 className="feature-title">Secure Play</h3>
              <p className="feature-description">
                Orion Stars uses advanced encryption and data protection to
                ensure secure play. Enjoy Orion Stars slots games or Sweepstakes
                fish game online with a safe gaming environment guaranteed.
              </p>
            </div>
          </Col>

          <Col xs={12} sm={12} md={6} lg={3} className="content-box mb-4">
            <div className="feature-card">
              <i className="bi bi-headset feature-icon"></i>
              <h3 className="feature-title">24/7 Customer Support</h3>
              <p className="feature-description">
                Get round-the-clock customer support. Contact us anytime if you
                have any technical issues or questions about a feature or your
                account.
              </p>
            </div>
          </Col>
        </Row>

        <Row className="variety-wrapper variety-wrapper-1">
          <Col xs={12} sm={12} md={6} lg={3} className="content-box mb-4">
            <div className="feature-card">
              <i className="bi bi-graph-up feature-icon"></i>
              <h3 className="feature-title">Live Leaderboards</h3>
              <p className="feature-description">
                Compete with real gamers worldwide. Keep track of your standing
                on the live leaderboard. Earn points, get rewards, and aim for
                the top spots.
              </p>
            </div>
          </Col>

          <Col xs={12} sm={12} md={6} lg={3} className="content-box mb-4">
            <div className="feature-card">
              <i className="bi bi-calendar-event feature-icon"></i>
              <h3 className="feature-title">Daily Challenges & Rewards</h3>
              <p className="feature-description">
                Play and win exciting daily challenges to earn free spins, extra
                bonuses, and rewards. There is always a new challenge to keep
                the excitement alive.
              </p>
            </div>
          </Col>

          <Col xs={12} sm={12} md={6} lg={3} className="content-box mb-4">
            <div className="feature-card">
              <i className="bi bi-wallet2 feature-icon"></i>
              <h3 className="feature-title">Fast & Secure Transactions</h3>
              <p className="feature-description">
                Orion Stars guarantees seamless and secure transactions with
                quick deposit and withdrawal. Your data and funds are protected
                using top-tier security protocols.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ExclusiveFeatures;
